/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createAtanh } from '../../factoriesAny.js';
export var atanhDependencies = {
  ComplexDependencies: ComplexDependencies,
  typedDependencies: typedDependencies,
  createAtanh: createAtanh
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAtanh.generated.js
// module id = 1487
// module chunks = 0